import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LoaderService } from './loader.service';

export class StudiosReuqest {
  public loaderId: string;
  public subscription: Subscription;

  constructor(init?: Partial<StudiosReuqest>) {
    Object.assign(this, init);
  }
}

@Injectable()
export class StudiosHttpClientService {

  public loaders: StudiosReuqest[] = [];

  constructor(private httpClient: HttpClient, private loaderService: LoaderService) { }

  public get<T>(
    url: string,
    options?: {
      headers?: HttpHeaders | { [header: string]: string | string[]; };
      observe?: 'body';
      params?: HttpParams | { [param: string]: string | string[]; };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    },
    loaderId?: string
  ): Observable<T> {
    this.loaderService.showLoader(loaderId)
    let req = this.loaders.find(x => x.loaderId === loaderId);
    if (!!req) {
      req.subscription.unsubscribe();
    } else {
      req = new StudiosReuqest({ loaderId });
      this.loaders.push(req);
    }
    const subject = new Subject<T>();
    req.subscription = this.httpClient.get<T>(url, options)
    .pipe(filter(x => !!x || (typeof (x) === 'number' && x === 0)))
    .subscribe({
      next: data => {
        this.loaders = this.loaders.filter(x => x.loaderId !== loaderId);
        this.loaderService.dismissLoader(loaderId);
        subject.next(data);
      },
      error: error => {
        this.loaderService.dismissLoader(loaderId);
      }});
    return subject.asObservable();
  }


  public post<T>(
    url: string,
    body: any,
    options?: {
      headers?: HttpHeaders | { [header: string]: string | string[]; };
      observe?: 'body';
      params?: HttpParams | { [param: string]: string | string[]; };
      reportProgress?: boolean;
      responseType?: 'json';
      withCredentials?: boolean;
    },
    loaderId?: string
  ): Observable<T> {
    this.loaderService.showLoader(loaderId);
    let req = this.loaders.find(x => x.loaderId === loaderId);
    if (!!req) {
      req.subscription.unsubscribe();
    } else {
      req = new StudiosReuqest({ loaderId });
      this.loaders.push(req);
    }
    const subject = new Subject<T>();
    req.subscription = this.httpClient.post<T>(url, body, options).subscribe(
      data => {
        this.loaders = this.loaders.filter(x => x.loaderId !== loaderId);
        this.loaderService.dismissLoader(loaderId);
        subject.next(data);
      },
      error => {
        this.loaderService.dismissLoader(loaderId);
      });
    return subject.asObservable();
  }
}
